import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Checkbox } from './ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LeadForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    birthDate: '',
    phone: '',
    email: '',
    insuranceAmount: '',
    callback: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSelectChange = (value) => {
    setFormData(prev => ({
      ...prev,
      insuranceAmount: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/submit-lead`, formData);
      
      if (response.data.success) {
        toast.success('Erfolgreich gesendet!', {
          description: response.data.message,
        });
        
        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          birthDate: '',
          phone: '',
          email: '',
          insuranceAmount: '',
          callback: false
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
      toast.error('Fehler', {
        description: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="lead-form" id="contact-form">
      <h3 className="form-title">Angebot unverbindlich anfordern</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <Label htmlFor="firstName">Vorname *</Label>
            <Input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <Label htmlFor="lastName">Nachname *</Label>
            <Input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>
        </div>

        <div className="form-group">
          <Label htmlFor="birthDate">Geburtsdatum *</Label>
          <Input
            type="date"
            id="birthDate"
            name="birthDate"
            value={formData.birthDate}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>

        <div className="form-group">
          <Label htmlFor="phone">Telefonnummer *</Label>
          <Input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            placeholder="+49 123 456789"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <Label htmlFor="email">E-Mail-Adresse *</Label>
          <Input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-control"
          />
        </div>

        <div className="form-group">
          <Label htmlFor="insuranceAmount">Gewünschte Versicherungssumme</Label>
          <Select onValueChange={handleSelectChange} value={formData.insuranceAmount}>
            <SelectTrigger className="form-control">
              <SelectValue placeholder="Bitte auswählen" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="5000">5.000 €</SelectItem>
              <SelectItem value="7500">7.500 €</SelectItem>
              <SelectItem value="10000">10.000 €</SelectItem>
              <SelectItem value="12500">12.500 €</SelectItem>
              <SelectItem value="15000">15.000 €</SelectItem>
              <SelectItem value="other">Anderer Betrag</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="checkbox-group">
          <Checkbox
            id="callback"
            name="callback"
            checked={formData.callback}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, callback: checked }))}
          />
          <Label htmlFor="callback" className="checkbox-label">
            Ja, ich möchte einen Rückruf zur persönlichen Beratung
          </Label>
        </div>

        <Button 
          type="submit" 
          className="btn-primary w-full"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Wird gesendet...' : 'Jetzt Angebot anfordern'}
        </Button>

        <p className="form-note">
          * Pflichtfelder. Ihre Daten werden vertraulich behandelt und nicht an Dritte weitergegeben.
        </p>
      </form>
    </div>
  );
};

export default LeadForm;
